<template>
	<NuxtLoadingIndicator color="#FFD60A"/>

	<!-- <div> -->
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>

	<UNotifications />
	<!-- </div> -->

	<UModals />
</template>

<script setup lang="ts">
useHead({
	script: [
		{ src: 'https://telegram.org/js/telegram-web-app.js?57' }
	],
	titleTemplate: (titleChunk) => {
		return titleChunk ? `${titleChunk} — STARK` : 'STARK';
	}
})

onMounted(() => {
  if ('serviceWorker' in navigator) {
	navigator.serviceWorker
	  .register('/sw.js')
	  .then((registration) => {
		console.log('Сервис-воркер зарегистрирован:', registration);
	  })
	  .catch((error) => {
		console.error('Ошибка регистрации сервис-воркера:', error);
	  });
  }
});
</script>
